import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export default makeStyles((theme: Theme) => ({
    Wrapper: {
        height: "auto",
        width: "100%", 
        position: "relative",
    },
    StatusesList: {
        paddingLeft: "10px",
        zIndex: 10,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        height: "70px",
        '& p': {
            fontSize: "larger",
        },
        '& span': {
            color: "orange",
            fontSize: "20px",
        }
    },
    StatusCell: {
        direction: "rtl",
        margin: "0",
        paddingRight: "5px",
        width: "100%",
        '& span': {
            color: "#fc7f03",
        }
    },
    StatusRow:  {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    TableHeader: {
        backgroundColor: "#fc7f03",
    }
}));
